import { Translatable } from '@spartacus/core';

/* SORT BY LABELS MODEL */
export interface SortLabelsModel {
  orderdateasc: string;
  orderdatedesc: string;
  ordernumberasc: string;
  ordernumberdesc: string;
  ponumberasc: string;
  ponumberdesc: string;
  ordertype: string;
  holdcodeasc: string;
  holdcodedesc: string;
  daterequestasc: string;
  daterequestdesc: string;
}

export interface BackorderSortLabelsModel {
  orderdateasc: string;
  orderdatedesc: string;
  deliverydateasc: string;
  deliverydatedesc: string;
  ordernumberasc: string;
  ordernumberdesc: string;
  itemnumberasc: string;
  itemnumberdesc: string;
  daterequestasc: string;
  daterequestdesc: string;
}

export interface InvoiceSortLabelsModel {
  invoicedatedesc: string;
  invoicedateasc: string;
  duedatedesc: string;
  duedateasc: string;
  ponumberdesc: string;
  ponumberasc: string;
  ordertype: string;
  paymentstatus: string;
  daysoverduedesc: string;
}
/* END OF SORT BY LABELS MODEL */

/* SORT BY OPTIONS */
export const SORT_OPTIONS = [
  {
    asc: false,
    code: 'orderdateasc',
    selected: false,
  },
  {
    asc: false,
    code: 'orderdatedesc',
    selected: false,
  },
  {
    asc: false,
    code: 'ordernumberasc',
    selected: false,
  },
  {
    asc: false,
    code: 'ordernumberdesc',
    selected: false,
  },
  {
    asc: false,
    code: 'ponumberasc',
    selected: false,
  },
  {
    asc: false,
    code: 'ponumberdesc',
    selected: false,
  },
  {
    asc: false,
    code: 'ordertype',
    selected: false,
  },
  {
    asc: false,
    code: 'holdcodeasc',
    selected: false,
  },
  {
    asc: false,
    code: 'holdcodedesc',
    selected: false,
  },
  {
    asc: false,
    code: 'daterequestasc',
    selected: false,
  },
  {
    asc: false,
    code: 'daterequestdesc',
    selected: false,
  },
];

export const BACKORDER_SORT_OPTIONS = [
  {
    asc: false,
    code: 'orderdateasc',
    selected: false,
  },
  {
    asc: false,
    code: 'orderdatedesc',
    selected: false,
  },
  {
    asc: false,
    code: 'deliverydateasc',
    selected: false,
  },
  {
    asc: false,
    code: 'deliverydatedesc',
    selected: false,
  },
  {
    asc: false,
    code: 'ordernumberasc',
    selected: false,
  },
  {
    asc: false,
    code: 'ordernumberdesc',
    selected: false,
  },
  {
    asc: false,
    code: 'itemnumberasc',
    selected: false,
  },
  {
    asc: false,
    code: 'itemnumberdesc',
    selected: false,
  },
  {
    asc: false,
    code: 'daterequestasc',
    selected: false,
  },
  {
    asc: false,
    code: 'daterequestdesc',
    selected: false,
  },
];

export const INVOICE_SORT_OPTIONS = [
  {
    asc: false,
    code: 'invoicedatedesc',
    selected: false,
  },
  {
    asc: false,
    code: 'invoicedateasc',
    selected: false,
  },
  {
    asc: false,
    code: 'duedatedesc',
    selected: false,
  },
  {
    asc: false,
    code: 'duedateasc',
    selected: false,
  },
  {
    asc: false,
    code: 'ponumberdesc',
    selected: false,
  },
  {
    asc: false,
    code: 'ponumberasc',
    selected: false,
  },
  {
    asc: false,
    code: 'ordertype',
    selected: false,
  },
  {
    asc: false,
    code: 'paymentstatus',
    selected: false,
  },
  {
    asc: false,
    code: 'daysoverduedesc',
    selected: false,
  },
];
/* END OF SORT BY OPTIONS */

/* INVOICE TABLE HEADER */
export const INVOICE_HEADERS = [
  { invoiceTableHeader: 'orders.invoiceHistory.invoiceNumberHeader', styleClass: 'header-invoice-number' },
  { invoiceTableHeader: 'orders.invoiceHistory.invoiceDateHeader', styleClass: 'header-invoice-date' },
  { invoiceTableHeader: 'orders.invoiceHistory.orderNumberHeader', styleClass: 'header-order-number' },
  { invoiceTableHeader: 'orders.invoiceHistory.orderTypeHeader', styleClass: 'header-order-type' },
  { invoiceTableHeader: 'orders.invoiceHistory.poNumberHeader', styleClass: 'header-po-number' },
  { invoiceTableHeader: 'orders.invoiceHistory.totalAmountHeader', styleClass: 'header-total-amount' },
  { invoiceTableHeader: 'orders.invoiceHistory.paymentStatusHeader', styleClass: 'header-payment-status' },
  { invoiceTableHeader: 'orders.invoiceHistory.dueDateHeader', styleClass: 'header-due-date' },
  { invoiceTableHeader: 'orders.invoiceHistory.daysOverdueHeader', styleClass: 'header-days-overdue' },
  { invoiceTableHeader: 'orders.invoiceHistory.totalOpenHeader', styleClass: 'header-total-open' },
];

export enum OrderHistoryStatus {
  OPEN = '1',
  CLOSED = '2',
  BACKORDER = '3',
}

export enum OrderView {
  ORDERS = 'orders',
  BACKORDER = 'backorder',
  INVOICE = 'invoice',
}

/* ORDER TYPES FILTER BUTTON */
export const DEFAULT_ORDER_HISTORY_TYPES = [
  {
    type: 'SO',
    label: 'orders.standard',
    disabled: false,
    flag: 'standard',
    show: true,
    selected: false,
  },
];

export const PLANNED_ORDER_HISTORY_TYPE = [
  {
    type: 'PO',
    label: 'orders.planned',
    disabled: false,
    flag: 'planned',
    show: true,
    selected: false,
  },
];

export const INVOICE_ADDITIONAL_ORDER_HISTORY_TYPES = [
  {
    type: 'SW',
    label: 'orders.warranty',
    disabled: false,
    flag: 'warranty',
    show: true,
    selected: false,
  },
  {
    type: 'CO',
    label: 'orders.returnOrders',
    disabled: false,
    flag: 'credit',
    show: true,
    selected: false,
  },
  {
    type: 'DO',
    label: 'orders.debitInvoices',
    disabled: false,
    flag: 'debit',
    show: true,
    selected: false,
  },
  {
    type: 'CN',
    label: 'orders.creditInvoices',
    disabled: false,
    flag: 'creditNotes',
    show: true,
    selected: false,
  },
];

/* SORT BY MAPPING */
export const SORT_MAPPING: { [key: string]: string } = {
  orderdateasc: 'orderDate:asc',
  orderdatedesc: 'orderDate:desc',
  deliverydateasc: 'deliveryDate:asc',
  deliverydatedesc: 'deliveryDate:desc',
  ordernumberasc: 'orderNumber:asc',
  ordernumberdesc: 'orderNumber:desc',
  ponumberasc: 'poNumber:asc',
  ponumberdesc: 'poNumber:desc',
  ordertype: 'orderType:desc',
  itemnumberasc: 'itemNumber:asc',
  itemnumberdesc: 'itemNumber:desc',
  daterequestasc: 'dateRequest:asc',
  daterequestdesc: 'dateRequest:desc',
  holdcodeasc: 'holdCode:asc',
  holdcodedesc: 'holdCode:desc',
};

export const INVOICE_SORT_MAPPING: { [key: string]: string } = {
  invoicedatedesc: 'invoiceDate:desc',
  invoicedateasc: 'invoiceDate:asc',
  duedatedesc: 'date:desc',
  duedateasc: 'date:asc',
  ponumberdesc: 'poNumber:desc',
  ponumberasc: 'poNumber:asc',
  ordertype: 'orderType:desc',
  paymentstatus: 'paymentStatus:asc',
  daysoverduedesc: 'daysOverdue:desc',
};
/* END OF SORT BY MAPPING */

export const DEFAULT_ORDER_HISTORY_TRANSLATIONS: OrderHistoryTranslatables = {
  orderViewBackorderBtn: { key: 'orders.articlesInBackOrder' },
  orderDate: { key: 'orders.date' },
  orderDateFrom: { key: 'orders.from' },
  orderDateTo: { key: 'orders.to' },
};
export interface OrderHistoryTranslatables {
  orderViewBackorderBtn?: Translatable;
  orderDate?: Translatable;
  orderDateFrom?: Translatable;
  orderDateTo?: Translatable;
}

export const ORDER_HISTORY_BASESITE_CONFIG_KEYS = {
  invoiceHistoryEnabled: 'shimano.invoicehistory.enabled',
  showExportCsv: 'shimano.orderhistory.exportcsv.enabled',
  showOrderRequestDate: 'shimano.orderhistory.date.request.enabled',
  showBackorderRequestDate: 'shimano.backorder.date.request.enabled',
  disabledOrderTypeSorting: 'shimano.orderhistory.order.type.disabled',
  displayExpectedShipmentDate: 'shimano.orderhistorydetails.expectedshipmentdate.enabled',
  disabledTax: 'shimano.orderhistorydetails.tax.disabled',
};
